export default __webpack_public_path__ + "static/media/Transition_Start-Private-5g.4c3e23e8.mp4";